/* Site-wide section reveal on scroll. Styles live in section-reveal-new.css. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var REVEAL_CLASSES = ['reveal-item', 'reveal-item--fade-only', 'is-revealed'];
  var CLEANUP_FALLBACK_MS = 1600;
  var SAFETY_NET_MS = 4000;

  function hasFixedOrStickyChild(section) {
    // Some sections load their CSS async (media="print" onload), so computed styles
    // may not be applied yet; a "sticky" class name is a cheap fallback signal.
    if (section.querySelector('[class*="sticky"]')) return true;
    var descendants = section.querySelectorAll('*');
    for (var i = 0; i < descendants.length; i++) {
      var position = window.getComputedStyle(descendants[i]).position;
      if (position === 'fixed' || position === 'sticky') return true;
    }
    return false;
  }

  function cleanup(el) {
    if (el._revealCleanedUp) return;
    el._revealCleanedUp = true;
    clearTimeout(el._revealTimer);
    el.removeEventListener('transitionend', el._revealOnEnd);
    REVEAL_CLASSES.forEach(function (cls) {
      el.classList.remove(cls);
    });
  }

  function reveal(el, observer) {
    if (el.classList.contains('is-revealed')) return;
    observer.unobserve(el);

    el._revealOnEnd = function (event) {
      if (event.target === el && event.propertyName === 'opacity') cleanup(el);
    };
    el.addEventListener('transitionend', el._revealOnEnd);
    el._revealTimer = setTimeout(function () {
      cleanup(el);
    }, CLEANUP_FALLBACK_MS);

    el.classList.add('is-revealed');
  }

  function init() {
    var viewportHeight = window.innerHeight;
    var candidates = document.querySelectorAll(
      '#MainContent > .shopify-section, .shopify-section-group-footer-group'
    );
    var targets = [];

    for (var i = 0; i < candidates.length; i++) {
      var section = candidates[i];
      if (section.offsetHeight <= 0) continue;
      // Anything on screen (or above it) at load stays untouched: no flash, no LCP impact.
      if (section.getBoundingClientRect().top <= viewportHeight) continue;
      if (section.querySelector('[data-reveal="none"]')) continue;
      // Rolex (.rx) content never animates (Rolex design guidelines).
      if (section.closest('.rx') || section.querySelector('.rx')) continue;

      var fadeOnly = !!section.querySelector('[data-reveal="fade"]') || hasFixedOrStickyChild(section);
      targets.push({ el: section, fadeOnly: fadeOnly });
    }

    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target, observer);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -20% 0px' }
    );

    targets.forEach(function (target) {
      target.el.classList.add('reveal-item');
      if (target.fadeOnly) target.el.classList.add('reveal-item--fade-only');
      observer.observe(target.el);
    });

    // Safety net: never leave an on-screen section hidden.
    function safetyNet() {
      setTimeout(function () {
        var height = window.innerHeight;
        targets.forEach(function (target) {
          var el = target.el;
          if (!el.classList.contains('reveal-item') || el.classList.contains('is-revealed')) return;
          var rect = el.getBoundingClientRect();
          if (rect.top < height && rect.bottom > 0) reveal(el, observer);
        });
      }, SAFETY_NET_MS);
    }

    if (document.readyState === 'complete') {
      safetyNet();
    } else {
      window.addEventListener('load', safetyNet, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
